import AddressTypes from 'common/Forms/AddressTypes';
import { ConcatAddressLine, GetCommonWFormWellFormedAddress, GetCommonWFormFieldPathValueMap } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

function GetSubstantialOwnerFieldPathValueMap(addressPath, wellFormedAddress) {
  const fieldPathValueDictionary = [
    {
      key: `${ addressPath }`,
      value: ConcatAddressLine(
        [wellFormedAddress?.addressLine1,
          wellFormedAddress?.addressLine2,
          wellFormedAddress?.addressLine3,
          wellFormedAddress?.addressLine4,
          wellFormedAddress?.addressPostalCode,
          wellFormedAddress?.addressCountry]
      )
    },
  ];

  return fieldPathValueDictionary;
}

function GetSubstantialOwnerWellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: ''
  };

  const splitLine = formAddress?.ownerAddress?.split(',')?.map(x => x.trim()) ?? null;

  if (splitLine === null) { return wellFormedAddress; }

  [wellFormedAddress.line1, wellFormedAddress.line2, wellFormedAddress.line3, wellFormedAddress.line4, wellFormedAddress.postalCode,
    ...wellFormedAddress.country] = splitLine;

  wellFormedAddress.country = wellFormedAddress.country.join(', ');

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormFieldPathValueMap('part1.permanentAddress', wellFormedAddress);
    case AddressTypes.Mailing:
      return GetCommonWFormFieldPathValueMap('part1.mailingAddress', wellFormedAddress);
    case AddressTypes.SubstantialOwner:
      return GetSubstantialOwnerFieldPathValueMap(`part29Owners[${ addressProps?.substantialOwnerIndex }].ownerAddress`, wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.permanentAddress);
    case AddressTypes.Mailing:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.mailingAddress);
    case AddressTypes.SubstantialOwner:
      return GetSubstantialOwnerWellFormedAddress(addressValues?.part29Owners && addressValues.part29Owners[addressProps?.substantialOwnerIndex]);
    default:
      break;
  }
}
